export const GET_CARD_BRAND_DEF= "GET_CARD_BRAND_DEF"
export const GET_CARD_BRAND_DEF_SUCCESS = "GET_CARD_BRAND_DEF_SUCCESS"
export const GET_CARD_BRAND_DEF_FAIL = "GET_CARD_BRAND_DEF_FAIL"

export const CARD_BRAND_DEF_API_ERROR = "API_ERROR"